import React from 'react';
export const VideoDemo: React.FC = () => {
  return <section className="py-7 px-4 bg-cream-dark/50" data-id="element-273">
      <div className="max-w-3xl mx-auto" data-id="element-274">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-2" data-id="element-275">
          Lo que tus hijos van a querer{' '}
          <span className="text-gold-dark" data-id="element-276">colorear primero</span>
        </h2>
        <p className="text-center text-textsoft mb-6 text-base font-semibold" data-id="element-277">
          Descubrí algunos de los personajes incluidos.
        </p>

        <div className="relative rounded-3xl overflow-hidden border-[6px] border-violet shadow-2xl bg-violet" data-id="element-278">
          <video src="https://cdn.shopify.com/videos/c/o/v/bb359617f3954230aff750492a49c6d5.mov" autoPlay muted loop playsInline controls={false} className="w-full h-full object-cover" data-id="element-279" />
        </div>
      </div>
    </section>;
};